import { render } from "./ProvisionUbuntu.vue?vue&type=template&id=1512346f&scoped=true"
import script from "./ProvisionUbuntu.vue?vue&type=script&lang=js"
export * from "./ProvisionUbuntu.vue?vue&type=script&lang=js"

import "./ProvisionUbuntu.vue?vue&type=style&index=0&id=1512346f&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ProvisionUbuntu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1512346f"]])

export default __exports__